import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8;'
axios.defaults.withCredentials = false
/**
 *
 * @description 可以控制跳转页面是否限制登录状态或者权限
 *
 * */
function getIpAddress() {
  let url = 'http://apis.juhe.cn/ip/ipNew?ip=42.84.36.21&key=3e27a77d2f053e568322ff6fe7735f23'
  axios
    .get(url)
    .then(res => {
      console.log('获取ip成功', res)
    })
    .catch(err => {
      console.log('获取ip失败', err)
    })
}

export { getIpAddress }



// WEBPACK FOOTER //
// ./src/global/modules/base.js